import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export let state = {
  organization: undefined,
};
const organization = localStorage.getItem('organization');

if (organization) {
  state.organization = JSON.parse(organization);
}
const namespaced = false;

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
